import { forwardRef, memo } from "react";

import { Button } from "@jti/core-components/components/Button";
import type { TextInputProps } from "@jti/ui";
import { TextInput, useTranslations } from "@jti/ui";
import { useDeviceBreakpoint } from "@jti/ui/hooks/useDeviceBreakpoint/useDeviceBreakpoint";

import styles from "../../PromoCodeView.module.scss";

type PromoCodeControlsProps = TextInputProps & {
  isPending: boolean;
};

export const PromoCodeControls = memo(
  forwardRef<HTMLInputElement, PromoCodeControlsProps>(({ isPending, ...props }, ref) => {
    const { __ } = useTranslations();
    const { breakpoint } = useDeviceBreakpoint();
    const isDesktop = breakpoint === "desktop";

    return (
      <div className={styles.voucherControls}>
        <TextInput
          {...props}
          id="promo-code-input"
          ref={ref}
          placeholder={__("cart.promo_code.field_placeholder")}
          maxLength={50}
          data-testid="promoCodeInput"
          containerClassName={styles.voucherInput}
        />
        <Button
          disabled={!props.value}
          pending={isPending}
          variant="secondary"
          type="submit"
          fullWidth={!isDesktop}
          data-testid="applyButton"
        >
          {__("cart.promo_code.apply_button")}
        </Button>
      </div>
    );
  })
);
